import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { TitleGrid } from '../../../components'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { anchorEl } = state.titleGrid
  return ({
    windowWidth: width,
    anchorEl,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    menu: {
      handleOpen: (event) => {
        dispatch(actions.titleGrid.menu.open(event.currentTarget))
      },
      handleClose: () => {
        dispatch(actions.titleGrid.menu.close())
      }
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TitleGrid)


// WEBPACK FOOTER //
// ./src/containers/Common/TitleGrid/TitleGrid.js